import React from "react";
import ShoppingCart from "./ShoppingCart";

function App() {
  return (
    <div className="app">
      <ShoppingCart />
    </div>
  );
}

export default App;
